export default "__VITE_ASSET__DVSSTJuB__"